import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { BRAND } from '../theme/landingTheme';

const logoStyle = {
  width: '140px',
  height: 'auto',
};

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © GetMarter '}
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 6 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: 'space-between',
          alignItems: { xs: 'center', sm: 'flex-start' },
          textAlign: { xs: 'center', sm: 'left' },
          gap: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box sx={{ ml: '-5px' }}>
            <img src={'/fulllogot.png'} style={logoStyle} alt="Logo of Marter" />
          </Box>
          <Typography variant="body2">
            Email us at: <strong>info@getmarter.com</strong>
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body2" fontWeight={600}>
            Community
          </Typography>
          <Link
            color="text.secondary"
            href="https://www.facebook.com/share/g/hr6idZ8zRkis9FKE/"
            target="_blank"
            rel="noopener"
          >
            Facebook group
          </Link>
          <Link
            color="text.secondary"
            href="https://www.youtube.com/playlist?list=PLevLP9Na0UzlfFKAYS0pPNqJlbKihTdhF"
            target="_blank"
            rel="noopener"
          >
            How-to videos
          </Link>
          <Link color="text.secondary" href="https://www.marteroa.com/" target="_blank" rel="noopener">
            Marter OA
          </Link>
          <Link color="text.secondary" href="/pioneers-dashboard">
            Pioneers dashboard
          </Link>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body2" fontWeight={600}>
            Legal
          </Typography>
          <Link color="text.secondary" href="/terms.pdf">
            Terms
          </Link>
          <Link color="text.secondary" href="/privacy">
            Privacy
          </Link>
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          maxWidth: '560px',
          textAlign: 'center',
          p: 2.5,
          borderRadius: '14px',
          backgroundColor: BRAND.tint,
          border: `1px solid ${BRAND.yellow}`,
        }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          Earn 30% monthly recurring commission
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Bring your friends to Marter and earn 30% of their subscription, every month.
          Email <strong>info@getmarter.com</strong> to join the affiliate program.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 6 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <div>
          <Copyright />
        </div>
        <Stack
          direction="row"
          justifyContent="left"
          spacing={1}
          useFlexGap
          sx={{ color: 'text.secondary' }}
        >
          <IconButton
            color="inherit"
            href="https://www.facebook.com/share/g/hr6idZ8zRkis9FKE/"
            aria-label="Facebook"
            sx={{ alignSelf: 'center' }}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            color="inherit"
            href="https://www.youtube.com/playlist?list=PLevLP9Na0UzlfFKAYS0pPNqJlbKihTdhF"
            aria-label="YouTube"
            sx={{ alignSelf: 'center' }}
          >
            <YouTubeIcon />
          </IconButton>
          <IconButton
            color="inherit"
            href="https://instagram.com/getmarter"
            aria-label="Instagram"
            sx={{ alignSelf: 'center' }}
          >
            <InstagramIcon />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}
